//
import PosSaleModel from '@/models/POS/PosSale'

/**
 * List of position sale tos.
 *
 * @class      PosSaleToList (name)
 */
export default class PosSaleToList extends PosSaleModel {

    /**
     * { item_description }
     */
    static includes = [
        //'g_branch_office',
        //'g_cashier_user.hr_employee',
        'g_seller_user.hr_employee',
        'g_state',
        //"g_supervisor_user.hr_employee",
        //'pos_cash_desk',
        //'pos_customer_credit_option',
        //'pos_manual_discount',
        //'pos_sale_pos_payment_types.pos_sale_payment_type',
        'pos_detail_sales',
        //'pos_detail_sales.wh_product',
        //'pos_detail_sales.wh_warehouse',
        // 'pos_sale_edited.pos_detail_sale_edited',
        //"pos_sale_edited.pos_detail_sale_edited.wh_product",
        //"pos_sale_edited.pos_detail_sale_edited.wh_warehouse",
        //'pos_sale_note',
        'pos_sale_type',
        'pos_sale_invoice_data',
        'sl_customer',
        //'sl_customer_branch_offices',
        //'sl_customer_branch_offices.g_commune',
        //'sl_sale_ticket',
        //"sl_sale_invoice.sl_customer_account_receivable",
        //'wh_sale_note',
    ]
}
